import { Action, Portal, useModal } from '@doveit/bricks';
import React from 'react';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { Invoice } from '../../../providers/api/dtos';
import ManageInvoiceCommissions from '../manage-invoice-commissions/ManageInvoiceCommissions';

interface ChildFnProps {
  manageCommissions: VoidFunction,
}

export interface ManageInvoiceCommissionsActionProps extends React.AriaAttributes {
  invoice: Invoice,
  children?: (props: ChildFnProps) => React.ReactNode,
  onSuccess?: (invoice: Invoice) => void,
}

const ManageInvoiceCommissionsAction: React.FC<ManageInvoiceCommissionsActionProps> = ({
  invoice,
  children,
  onSuccess,
  ...rest
}) => {
  const modal = useModal();
  return (
    <>
      {children?.({ manageCommissions: modal.open }) || (
        <Action
          aria-label="Azione per gestire le commissioni relative al pagamento"
          {...rest}
          label="Gestisci"
          size="S"
          onClick={() => modal.open()}
        />
      )}
      <Portal>
        <SimpleModal
          {...modal}
          title="Gestisci commissioni"
          aria-label="Modale per gestire le commissioni relative al pagamento"
        >
          <ManageInvoiceCommissions invoice={invoice} onUpdate={onSuccess} />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default ManageInvoiceCommissionsAction;
